module.exports = __webpack_public_path__ + "static/media/consultancy_carousel.6a9b44a9.jpg";